import gql from 'graphql-tag'
import { CreateViocLeadInput, Mutation, MutationCreateViocLeadArgs } from '../../generated/nest-graphql'
import queryString from 'query-string'
import { newBackendClient } from '../clients/new-backend.client'
import Cookies from 'js-cookie'

export const createViocLead = async (input: CreateViocLeadInput) => {
  const campaignUrl = Cookies?.get('__gtm_campaign_url') ?? null
  const campaignQueryParams = campaignUrl ? queryString?.parseUrl(campaignUrl)?.query : null

  return await newBackendClient.mutate<Mutation, MutationCreateViocLeadArgs>({
    variables: {
      createViocLeadInput: {
        phoneNumber: input.phoneNumber,
        extraFields: input.extraFields,
        windowUrl: window?.location?.href ?? null,
        queryParams: campaignQueryParams,
      },
    },
    mutation: gql`
      mutation createViocLead($createViocLeadInput: CreateViocLeadInput!) {
        createViocLead(createViocLeadInput: $createViocLeadInput) {
          id
        }
      }
    `,
  })
}
